import { TableData, leadData, dealData, taskData } from "./CRM";
import { sales, orders, products } from "./ecommerce";
import { instructor, recentcourse, instructorList } from "./learning";
import { property, feedback, saleproperty, rentproperty } from "./realestate";
import { listingGrid, listinglist } from "./appRealestate";
import { agentlistdata } from "./agent";
import { agencies } from "./agency";
import { supporttickets, assignesTickets, ticketList } from "./ticket";
import { messages, attachementsData, chatContactData, chatData, callsData, bookmarkData,ChannelsData } from "./chat";
import { productList } from "./product";
import { customerList } from "./customer";
import { invoicesList, invoice } from "./invoice";
import { sellerOverview } from "./seller";
import { orderList } from "./order";
import { listinglistcard, estateList } from "./appRealestate";
import { earningcard, earningdata } from "./realestate";
import { courseList, courseGrid } from "./cources";
import { sellerList } from "./seller";
import { subscription } from "./students"
import { cources } from "./students"
export {
    TableData, leadData, dealData, taskData, sales, orders, products, instructor, recentcourse, property, feedback,
    saleproperty, rentproperty, listingGrid, listinglist, agentlistdata, agencies, supporttickets, assignesTickets, ticketList,
    messages, chatContactData, chatData, ChannelsData,attachementsData,callsData, bookmarkData, productList, customerList, invoicesList, invoice, sellerOverview, orderList, estateList, listinglistcard,
    earningdata, earningcard, instructorList,
    courseList, sellerList, cources,
    subscription, courseGrid
}